import React, { useState, useEffect } from "react";
import Input from "components/ui/Input";
import Button from "components/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  createShippingSettingService,
  getAllgovernoratesService,
  getShippingService, // تأكد من استيرادها
} from "redux/services/general_service";
import { toast } from "react-toastify"; // إذا كنت تستخدمها

const AddShippingSetting = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { governoratesList } = useSelector((state) => state.general);

  // States لتخزين الاختيارات
  const [selectedGovernorateId, setSelectedGovernorateId] = useState("");
  const [provinces, setProvinces] = useState([]); // المناطق التابعة للمحافظة
  const [selectedProvinceId, setSelectedProvinceId] = useState("");
  
  const [costInfo, setCostInfo] = useState("");
  const [expectedTime, setExpectedTime] = useState("");

  // 1. تحديث قائمة المناطق (provinces) عند اختيار محافظة (governorate)
  const handleGovernorateChange = (e) => {
    const govId = e.target.value;
    setSelectedGovernorateId(govId);
    setSelectedProvinceId(""); // تصفير المنطقة المختارة عند تغيير المحافظة

    // البحث عن المحافظة المختارة داخل البيانات لجلب مناطقها
    const selectedGov = governoratesList?.find(gov => gov.id === parseInt(govId));
    if (selectedGov) {
      setProvinces(selectedGov.provinces || []);
    } else {
      setProvinces([]);
    }
  };

  if (!isOpen) return null;

  const handleSubmit = () => {
    if (!selectedProvinceId) {
      toast.error("يرجى اختيار المنطقة");
      return;
    }

    const payload = {
      province_id: selectedProvinceId,
      cost_info: costInfo,
      expected_time: expectedTime,
    };

    dispatch(createShippingSettingService(payload)).then((response) => {
      if (response.payload?.status === 200) {
        toast.success("تم إضافة معلومات الشحن بنجاح");
        dispatch(getShippingService());
        onClose();
      }
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h2 className="text-lg font-semibold mb-4">إعدادات الشحن</h2>

        <div className="space-y-4">
          {/* اختيار الدولة/المحافظة الرئيسية */}
          <div>
            <label className="block text-sm font-medium mb-1">اختر الدولة/المحافظة</label>
            <select
              className="w-full p-2 border rounded-md"
              value={selectedGovernorateId}
              onChange={handleGovernorateChange}
            >
              <option value=""> اختر الدولة</option>
              {governoratesList?.map((gov) => (
                <option key={gov.id} value={gov.id}>
                  {gov.translations?.ar?.name || gov.name}
                </option>
              ))}
            </select>
          </div>

          {/* اختيار المنطقة (Province) */}
          <div>
            <label className="block text-sm font-medium mb-1">اختر المنطقة</label>
            <select
              className="w-full p-2 border rounded-md"
              value={selectedProvinceId}
              onChange={(e) => setSelectedProvinceId(e.target.value)}
              disabled={!provinces.length}
            >
              <option value=""> اختر المنطقة</option>
              {provinces.map((prov) => (
                <option key={prov.id} value={prov.id}>
                  {prov.translations?.ar?.name || prov.name}
                </option>
              ))}
            </select>
          </div>

          <Input
            label="التكلفة"
            value={costInfo}
            onChange={(e) => setCostInfo(e.target.value)}
            placeholder="مثال: 10 دينار عراقي"
          />

          <Input
            label="الوقت المتوقع"
            value={expectedTime}
            onChange={(e) => setExpectedTime(e.target.value)}
            placeholder="مثال: 2-3 أيام"
          />
        </div>

        <div className="flex justify-end space-x-2 mt-6 gap-2">
          <Button variant="outline" onClick={onClose}>
            إلغاء
          </Button>
          <Button onClick={handleSubmit}>حفظ</Button>
        </div>
      </div>
    </div>
  );
};

export default AddShippingSetting;